export const PaymentSummary = {
  PaymentTotal: 'payment-total',
  CreditsBalance: 'credits-balance',
};
